import Axios from "axios";

let aiBaseURL = (process.env.VUE_APP_API_URL || "https://api.arboran.com.br/api/")
  .replace(/\/api\/$/, "/ai-service/api/v1");
if (process.env.NODE_ENV === "development") {
  aiBaseURL = "http://localhost:8000/api/v1";
}

const aiHttp = Axios.create({ baseURL: aiBaseURL });
const local = JSON.parse(localStorage.getItem("user-token") || "null");
if (local && local.token) {
  aiHttp.defaults.headers.common["Authorization"] = "bearer " + local.token;
}

// Recursos compartilhados das artes de divulgação (diagnóstico, workshop, audiência pública)
class ArtworkService {
  // Logos configuradas da conta: [{ code, label, url }]
  GetLogos(contaId) {
    return aiHttp({ url: "/artwork/logos/" + contaId, method: "GET" });
  }
}

export default new ArtworkService();
